import {Video} from './Video'
(async function(){
    const $videoBanner = document.querySelectorAll('.banner-video')
    $videoBanner.forEach($v => new Video.VideoBanner($v))
})()

